module.exports = __webpack_public_path__ + "static/img/software.637f17da.jpg";